import React, { useState, useMemo } from 'react'

import BaseLayout from '../../common/components/BaseLayout'

import Tab from '../../tabs/components/Tab'
import HiddenTab from '../../tabs/components/HiddenTab'
import TabMenu from '../../tabs/components/TabMenu'
import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'

import PostList from '../../sitrep/components/PostList'
import Post from '../../sitrep/components/Post'
import PostFilter from '../../sitrep/components/PostFilter'
import CreateForm from '../../sitrep/components/CreateForm'

import { useIsSelected } from '../../tabs/hooks'
import { usePostsByIncidentId } from '../../sitrep/hooks'

import styles from './MainLayout.module.css'

const MainLayout = () => {
  const [incidentId, setIncidentId] = useState(null)
  const [queryString, setQueryString] = useState('')
  const [esf, setESF] = useState(null)
  const isListPage = useIsSelected('/sitrep')

  const [
    { response: posts, isLoading: postsAreLoading },
    { refresh },
  ] = usePostsByIncidentId(incidentId)

  const filteredPosts = useMemo(() => {
    if (postsAreLoading || !posts) return []
    return posts
      .filter((post) => {
        if (queryString === '') return true
        const {
          additionalInfo,
          author,
          currentStatus,
          futureConcerns,
          incident,
          limitations,
          subject,
        } = post
        const concat = `${additionalInfo} ${author} ${currentStatus} ${post.esf} ${futureConcerns} ${incident} ${limitations} ${subject}`
        return concat.toUpperCase().includes(queryString.toUpperCase())
      })
      .filter((post) => esf === null || post.esf === esf.label)
  }, [posts, postsAreLoading, queryString, esf])

  return (
    <BaseLayout title="Sitrep">
      <div style={{ marginTop: 50, display: 'flex' }}>
        <div className={styles.tabBar}>
          <TabMenu>
            <Tab path="/sitrep" icon="fa fa-list-ul" />
            <HiddenTab path="/sitrep/:postId(\d+)" icon="far fa-clipboard" />
            <Tab path="/sitrep/add" icon="fa fa-plus" />
          </TabMenu>
        </div>
        {isListPage && (
          <div className={styles.sideBar}>
            <TabPanelContainer>
              <TabPanel path="/sitrep">
                <PostFilter
                  queryString={queryString}
                  setQueryString={setQueryString}
                  incidentId={incidentId}
                  setIncidentId={setIncidentId}
                  esf={esf}
                  setESF={setESF}
                />
              </TabPanel>
            </TabPanelContainer>
          </div>
        )}
        <div className={isListPage ? styles.listPageContent : styles.content}>
          <TabPanelContainer>
            <TabPanel path="/sitrep/add">
              <CreateForm incidentId={incidentId} />
            </TabPanel>
            <TabPanel path="/sitrep/:postId(\d+)" component={Post} />
            <TabPanel path="/sitrep">
              <PostList posts={filteredPosts} />
            </TabPanel>
          </TabPanelContainer>
        </div>
      </div>
    </BaseLayout>
  )
}

export default MainLayout
